import { Users, Home, MapPin, Store } from "lucide-react";
import { STATS_DATA } from "../data";

export default function ReusableStats() {
  
  // Dynamic icon helper to return precise Lucide icons based on standard strings
  const renderIcon = (iconName: string) => {
    const iconClass = "w-6 h-6 text-primary stroke-[1.75]";
    switch (iconName) {
      case "Users":
        return <Users className={iconClass} />;
      case "Home":
        return <Home className={iconClass} />;
      case "MapPin":
        return <MapPin className={iconClass} />;
      case "Store":
        return <Store className={iconClass} />;
      default:
        return <Users className={iconClass} />;
    }
  };

  return (
    <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8 mb-8">
      <div className="bg-white rounded-3xl shadow-xl hover:shadow-2xl hover:shadow-[#005c32]/5 p-6 md:p-8 border border-slate-100 transition-all duration-300">
        
        {/* Responsive Grid layout */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-0 divide-y lg:divide-y-0 lg:divide-x divide-slate-100">
          {STATS_DATA.map((item, index) => (
            <div 
              key={item.id} 
              className={`flex flex-col items-center justify-center text-center p-4 transition-all duration-300 group hover:scale-102 ${
                index >= 2 ? "pt-6 lg:pt-0 lg:p-4" : ""
              }`}
            >
              
              {/* Circular Green Outline Container as requested */}
              <div className="w-14 h-14 rounded-full border-2 border-[#005c32]/10 bg-slate-50 flex items-center justify-center mb-3 group-hover:border-[#005c32] group-hover:bg-[#005c32]/5 transition-all duration-300 shadow-sm">
                {renderIcon(item.iconName)}
              </div>

              {/* Huge Bold Value count */}
              <span className="text-3xl sm:text-4xl font-extrabold text-[#005c32] tracking-tight font-sans">
                {item.value}
              </span>

              {/* Title metric label in yellow/gold tone style */}
              <span className="text-xs font-bold text-[#ff7a00] tracking-widest uppercase mt-1">
                {item.label}
              </span>

              {/* Brief descriptive text */}
              <span className="text-xs text-slate-500 font-medium mt-1">
                {item.description}
              </span>

            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
